import SucursalesAPI from '@/api/sucursales/sucursal.js' // asumimos que tenés algo así

export default {
 async seleccionarSucursal({ commit }, { uuid_empresa, uuid_sucursal }) {
    try {
      const response = await SucursalesAPI.show(uuid_sucursal)
      commit('SET_SUCURSAL', response.data)
      return response.data  // ✅ importante si querés usarla después
    } catch (error) {
      console.error('Error cargando sucursal', error)
      commit('CLEAR_SUCURSAL')
      throw error  // ❗️lanza el error para que beforeEach pueda actuar
    }
  },

  salirDeSucursal({ commit }) {
    commit('CLEAR_SUCURSAL')
  },
}